import { render, staticRenderFns } from "./DocumentCustomer.vue?vue&type=template&id=13d32cde"
import script from "./DocumentCustomer.vue?vue&type=script&lang=js"
export * from "./DocumentCustomer.vue?vue&type=script&lang=js"
import style0 from "./DocumentCustomer.vue?vue&type=style&index=0&id=13d32cde&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports